// @repo/observability/errors — Error reporting interfaces and utilities

export interface ErrorReporter {
  captureException(error: Error, extra?: Record<string, unknown>): void
  captureMessage(message: string, extra?: Record<string, unknown>): void
}

/**
 * Create a composite error reporter that fans out to all provided sinks.
 */
export function createErrorReporter(...sinks: ErrorReporter[]): ErrorReporter {
  return {
    captureException(error: Error, extra?: Record<string, unknown>) {
      for (const sink of sinks) {
        try {
          sink.captureException(error, extra)
        } catch {
          /* best-effort: don't let one sink abort the fan-out */
        }
      }
    },
    captureMessage(message: string, extra?: Record<string, unknown>) {
      for (const sink of sinks) {
        try {
          sink.captureMessage(message, extra)
        } catch {
          /* best-effort: don't let one sink abort the fan-out */
        }
      }
    }
  }
}
